
import { Vue, Component, Prop } from 'vue-property-decorator';
import PieChart from 'vue-pie-chart/src/PieChart.vue'

@Component({
	components: {
		PieChart
	}
})
export default class IntakeChart extends Vue {
	@Prop() title!: string;
	@Prop() description!: string;
	@Prop() percent!: number;
	@Prop() animate!: boolean;

	private chartPercent:number = 0;

	beforeMount() {
		if (this.animate) {
			this.chartPercent = this.percent;
		} else {
			this.chartPercent = this.percent;
		}
	}
}
